// 列表组件需要的数据
export const OPTHINES = {
  voteName: '2020project/2020chinastory',
  mustSearch: 'Button',
  number: {
    mustRank: true,
  },
  listData: {
    type: 'com',
  },
  themeColor: {
    activeBgColor: '#2365d6',
    inactiveBgColor: '#fff',
  },
  tabs: [
    {
      tabName: '参赛',
      tabPath: '/20200728CHINASTORY/Enroll',
    },
    {
      tabName: '新闻',
      tabPath: '/20200728CHINASTORY/News',
    },
    {
      tabName: '作品',
      tabPath: '/20200728CHINASTORY/List',
    },
  ],
};
